import { useEffect } from 'react';

import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import AlertIcon from '@perpay-web/fintech/assets/images/alertIcon.svg';
import { getBiometricsLabelFromType } from '@perpay-web/native-client/selectors/passkey';
import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './BiometricRegistrationFailedModal.scss';

const BiometricRegistrationFailedModal = ({
    onMount = noop,
    className,
    onClickClose,
    biometricsType,
}) => {
    useEffect(() => {
        onMount();
    }, [onMount]);

    const biometricsLabel = getBiometricsLabelFromType(biometricsType);

    return (
        <BottomSheet
            onClose={onClickClose}
            className={getClassName(styles.modal, className)}
        >
            <div className={styles['copy-container']}>
                <img
                    width='105'
                    height='105'
                    src={AlertIcon}
                    alt='Warning'
                    className={styles.icon}
                />
                <div className={styles.header}>
                    {biometricsLabel} login not enabled
                </div>
                <div className={styles.copy}>
                    You&apos;re successfully logged in, but we weren&apos;t able
                    to turn on {biometricsLabel} for future logins. You can try
                    again next time you login.
                </div>
            </div>
            <div className={styles['close-button-container']}>
                <CustomButton action='primary' onClick={onClickClose}>
                    Close
                </CustomButton>
            </div>
        </BottomSheet>
    );
};

export default BiometricRegistrationFailedModal;
